import useCieloTDCContext from 'components/cielo/CieloTDCContext/useCieloTDCContext';

/**
 * useCieloTDCPayment hook.
 * Bridge between the payment handler registry and the CieloTDCContext.
 * Exposes executePayment (calls submitForm) and isLoading from the Cielo TDC provider.
 * Must be used inside a CieloTDCProvider.
 * @returns {object} executePayment and isLoading.
 */
function useCieloTDCPayment() {
  const { submitForm, isLoading } = useCieloTDCContext();

  return {
    executePayment: submitForm,
    isLoading,
  };
}

export default useCieloTDCPayment;
